import { BA_STOPS } from "./routePages";

// Foto y descripción breve de cada ciudad de la franja (los pueblos usan la foto de su región).
const INFO = {
  Retiro: ["baires", "La terminal de ómnibus más grande del país, en la Ciudad de Buenos Aires."],
  Liniers: ["baires", "Barrio del oeste porteño, sobre el límite con el conurbano."],
  "Terminal Dellepiane": ["baires", "Terminal de ómnibus sobre la Av. Dellepiane, en el sur de la Ciudad."],
  "San Justo": ["baires", "Cabecera del partido de La Matanza, en el oeste del conurbano."],
  Pacheco: ["baires", "General Pacheco, en el partido de Tigre, zona norte del conurbano."],
  Escobar: ["parana", "Partido de zona norte, conocido por su Fiesta Nacional de la Flor."],
  Campana: ["parana", "Ciudad industrial a orillas del río Paraná."],
  Rosario: ["rosario", "La Cuna de la Bandera, a orillas del Paraná y con el Monumento a la Bandera."],
  "Santa Fe": ["parana", "Capital provincial, rodeada de ríos y lagunas del litoral."],
  "San Cristóbal": ["ruta", "Ciudad del norte santafesino, tradicional nudo ferroviario."],
  "La Banda": ["santiago", "La segunda ciudad de la provincia, frente a la capital sobre el río Dulce."],
  "Santiago del Estero": ["santiago", "La Madre de Ciudades, la ciudad más antigua del país."],
  "Termas de Río Hondo": ["termas", "Famosa por sus aguas termales y su autódromo internacional."],
  Tucumán: ["tucuman", "El Jardín de la República, donde se declaró la Independencia."],
  Añatuya: ["interior", "Ciudad del este santiagueño, cabecera del departamento General Taboada."],
  Frías: ["interior", "Ciudad del oeste santiagueño, cerca del límite con Catamarca."],
  "Monte Quemado": ["interior", "Ciudad del norte santiagueño, cerca del límite con Salta y Chaco."],
};
const SANTA_FE_NORTE = ["Campo Garay", "Logroño", "Tostado"];

export const cityInfo = (c) => {
  if (INFO[c]) return { img: `/img/${INFO[c][0]}.jpg`, text: INFO[c][1] };
  if (BA_STOPS.includes(c)) return { img: "/img/baires.jpg", text: "Parada del conurbano bonaerense, con salidas directas al norte del país." };
  if (SANTA_FE_NORTE.includes(c)) return { img: "/img/ruta.jpg", text: "Localidad del norte santafesino, en el camino hacia Santiago del Estero." };
  return { img: "/img/interior.jpg", text: "Localidad del interior santiagueño, conectada con Buenos Aires y la capital." };
};
